import React from 'react';
import { Lightbulb } from 'lucide-react';

interface TipBoxProps {
  children: React.ReactNode;
}

export const TipBox: React.FC<TipBoxProps> = ({ children }) => {
  return (
    <div className="mt-3 flex items-start gap-2 text-sm bg-yellow-100 dark:bg-yellow-900/20 p-3 py-2 rounded-lg border border-yellow-200 dark:border-yellow-700/30">
      <Lightbulb className="w-4 h-4 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
      <span className="text-yellow-800 dark:text-yellow-300">{children}</span>
    </div>
  );
};
